import React from "react";
import { FaShippingFast } from "react-icons/fa";

const ProductStrength = () => {
  return (
    <div className=" border-bottom  ">
      {/* content-space-t-2 content-space-t-lg-3 */}
      <div className="container content-space-2">
        <h2 className="text-center"> Our Strength </h2>

        <div className="row content-space-t-2 ">
          <div className="col-md-4 mb-7 mb-md-0">
            <div className="d-flex">
              <div className="flex-shrink-0">
                <img
                  className="avatar avatar-4x3"
                  src="../assets/img/svg/illustrations/oc-protected-card.svg"
                  alt=" Description"
                />
              </div>
              <div className="flex-grow-1 ms-4">
                <h4 className="mb-1">Secure checkout</h4>
                <p className="small mb-0">Guaranteed safe checkout</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-7 mb-md-0">
            <div className="d-flex">
              <div className="flex-shrink-0">
                <img
                  className="avatar avatar-4x3"
                  src="../assets/img/svg/illustrations/oc-return.svg"
                  alt=" Description"
                />
              </div>
              <div className="flex-grow-1 ms-4">
                <h4 className="mb-1">30 Days return</h4>
                <p className="small mb-0">
                  We offer you a full refund within 30 days of purchase.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="d-flex">
              <div className="flex-shrink-0">
                <img
                  className="avatar avatar-4x3"
                  src="../assets/img/svg/illustrations/oc-truck.svg"
                  alt=" Description"
                />
              </div>
              <div className="flex-grow-1 ms-4">
                <h4 className="mb-1">Free shipping</h4>
                <p className="small mb-0">
                  Automatically receive free standard shipping on every order.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductStrength;
